var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-scrollbar",style:({ maxHeight: _vm.height })},[_c('div',{staticClass:"left-scrollbar-children"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }